import { createFileRoute } from '@tanstack/react-router'
import { ScTelephonyPage } from '@/features/support-coordination/telephony'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/telephony',
)({
  component: ScTelephonyPage,
})
